<template>
  <v-container>
    <v-row justify="center">
      <v-col :lg="4">
        <v-card>
          <v-card-title>
            <h3 class="headline">{{ $t('New password') }}</h3>
          </v-card-title>
          <form @submit.prevent="submit">
            <v-card-text>
              <validation-observer ref="form">
                <validation-provider v-slot="{errors}" name="email" rules="required|email|max:255">
                  <v-text-field
                    name="email"
                    :label="$t('E-mail')"
                    id="email"
                    type="email"
                    v-model="email"
                    :error-messages="errors"
                    required
                  ></v-text-field>
                </validation-provider>
                <validation-provider
                  v-slot="{errors}"
                  name="password"
                  rules="required|min:8|max:255"
                >
                  <v-text-field
                    name="password"
                    :label="$t('Password')"
                    id="password"
                    :type="showPassword ? 'text' : 'password'"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPassword = !showPassword"
                    v-model="password"
                    :error-messages="errors"
                    required
                  ></v-text-field>
                </validation-provider>
                <validation-provider
                  v-slot="{errors}"
                  name="password_confirmation"
                  rules="required|min:8|max:255|confirmed:password"
                >
                  <v-text-field
                    name="password_confirmation"
                    :label="$t('Password confirmation')"
                    id="password_confirmation"
                    :type="showPasswordConfirmation ? 'text' : 'password'"
                    :append-icon="showPasswordConfirmation ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPasswordConfirmation = !showPasswordConfirmation"
                    v-model="password_confirmation"
                    :error-messages="errors"
                    required
                  ></v-text-field>
                </validation-provider>
              </validation-observer>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" :to="{name: 'Welcome'}">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" :loading="loading" color="success">{{ $t('Change password') }}</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import auth from "@/api/auth";
import snackbar from "@/mixins/snackbar";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "PasswordUpdateForm",
  components: { ValidationObserver, ValidationProvider },
  mixins: [snackbar],
  data() {
    return {
      email: this.$route.query.email ?? "",
      password: "",
      password_confirmation: "",
      error: false,
      success: false,
      loading: false,
      showPassword: false,
      showPasswordConfirmation: false
    };
  },
  methods: {
    submit() {
      this.$refs.form.validate().then(success => {
        if (!success) {
          return;
        }
        this.loading = true;
        const data = {
          token: this.$route.params.token,
          email: this.email,
          password: this.password,
          password_confirmation: this.password_confirmation
        };

        auth
          .updatePassword(data)
          .then(() => {
            this.snackbar("success", this.$t("Your password has been reset!"));
            this.loading = false;
          })
          .catch(error => {
            if (error.response && error.response.status === 422) {
              let errors = error.response.data.errors;
              this.$refs.form.setErrors(errors);
            } else {
              this.snackbar(
                "error",
                this.$t(
                  "An error occured during resetting your password, please try again"
                )
              );
            }
            this.loading = false;
          });
      });
    }
  }
};
</script>